<template>
	<div id="main">
		<div id="sz-banner" class="shizhan-banner">
			<div class="info-bg" id="js-info-bg">
				<div class="cover-mask"></div>
			</div>
			<div class="wrap clearfix">
				<div class="sz-banner-left">
					<div class="crumbs clearfix">
						<a href="/">机器人编程</a>
						<i>\</i>
						<span>初级</span>
						<i>\</i>
						<span>AI仿生机器人编程课程</span>
					</div>
					<h2 class="course-title">
		                <a href="javascript:void(0)">AI仿生机器人编程课程</a>
		            </h2>
					<div class="shizhan-nav clearfix">
						<a href="javascript:;" class="clearfix on">
							<i class="fa fa-book"></i>
							<span>课程</span>
						</a>
						<a href="javascript:;">
							<i class="fa fa-question-circle"></i>
							<span>问答</span>
						</a>

						<a href="javascript:;">
							<i class="fa fa-pencil-square-o"></i>
							<span>作业</span>
						</a>

						<a href="javascript:;">
							<i class="fa fa-cloud-download"></i>
							<span>资料</span>
						</a>

					</div>
				</div>
			</div>
		</div>
		<div class="learn-container clearfix">

			<div class="learn-container-left">

				<div class="learn-container-nav clearfix">
					<a href="javascript:;" class="active">章节</a>
					<a href="javascript:;">更新日志</a>
				</div>

				<div class="learn-course-list">
					<div class="list-item">
						<h3>第1章 三色LED灯</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;" @click="toChapter(1)"><span class="title_info">1.1 UNO主板</span><span class="course-time r">(08:40)</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;" @click="toChapter(2)"><span class="title_info">1.2 连接LED红灯</span><span class="course-time r">(11:36)</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;" @click="toChapter(3)"><span class="title_info">1.3 点亮LED红灯</span><span class="course-time r">(13:49)</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;" @click="toChapter(4)"><span class="title_info">1.4 让LED灯闪烁 </span><span class="course-time r">(17:41)</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;" @click="toChapter(5)"><span class="title_info">1.5 调节LED灯亮度 </span><span class="course-time r">(18:30)</span></a>
							</li>
						</ul>
					</div>
					<!--<div class="list-item">
						<h3>第2章 智能坦克</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.1 超声波传感器 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.2 搭建智能坦克 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.3 智能悬停程序 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.4 智能跟随程序 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.5 智能避障程序 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">2.6 无人驾驶程序 </span><span class="course-time r">未发布</span></a>
							</li>
						</ul>
					</div>
					<div class="list-item">
						<h3>第3章 智能交通</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">3.1 智能交通信号灯 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">3.2 智能岗亭 </span><span class="course-time r">未发布</span></a>
							</li>
						</ul>
					</div>
					<div class="list-item">
						<h3>第4章 颜色分拣器</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">4.1 灰度传感器 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">4.2 搭建颜色分拣器 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">4.3 编写颜色分拣程序 </span><span class="course-time r">未发布</span></a>
							</li>
						</ul>
					</div>
					<div class="list-item">
						<h3>第5章 叉车竞技场</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">5.1 搭建叉车 </span><span class="course-time r">未发布</span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">5.2 红外遥控器 </span><span class="course-time r">未发布 </span></a>
							</li>
							<li class="">
								<i class="fa fa-video-camera ileft"></i><em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">5.3 叉车竞技场</span><span class="course-time r">未发布</span></a>
							</li>
						</ul>
					</div>
					<div class="list-item">
						<h3>第6章 推土机竟技场</h3>
						<ul>
							<li class="">
								<i class="fa fa-video-camera ileft"></i>
								<em class="type-text">视频：</em>
								<a href="javascript:;"><span class="title_info">6.1 搭建推土机 </span><span class="course-time r">未发布</span></a>
							</li>
						</ul>
					</div>-->
				</div>
			</div>
			<div class="learn-course-right">
				<div class="course-sidebar-title">
					<h3 class="clearfix">
				        <span class="span">课程摘要</span>
				     </h3>
				</div>

				<div class="course-sidebar evaluate">
					<h2>综合评分</h2>
					<h3>9.99</h3>

					<p>AI仿生机器人编程课程由点亮三色LED灯、智能开关、乐高舵机、电机组成，让机器人按照程序要求来完成一系列复杂的动作。
					</p>
					<div class="course-score-info clearfix">
						<dl>
							<dt>难度</dt>
							<dd>初级</dd>
						</dl>
						<dl>
							<dt>时长</dt>
							<dd>11小时0分钟</dd>
						</dl>
						<dl>
							<dt>章节</dt>
							<dd>20</dd>
						</dl>
					</div>

				</div>

				<div class="course-sidebar porject">
					<div class="item">
						<a href="javascript:;" class="href_btn">资料下载</a>
						<p>源代码及教辅材料下载</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'TeachTcenterContent',
		data() {
			return {
				classList: [],
				userList: [],
				cid: null,
				cname: null,
				teacherInfo: null
			}
		},
		methods: {
			torobot(uid) {
				var ustr = 'u' + uid + "/mcode/"
				window.open("https://itmsw.cn/course/m-coding.html?userFileRoot=" + ustr)
			},
			totuxing(uid) {
				var ustr = 'u' + uid + "/mcode/"
				window.open("https://itmsw.cn/course/v-coding.html?userFileRoot=" + ustr)
			},
			qh(cid, cname) {
				this.cid = cid
				this.cname = cname
				this.queryByClassId(this.cid)
			},
			queryByClassId(cid) {
				axios.get('/itmswcn/userClass/class/query/' + cid)
					.then(this.queryByClassIdSucc)
			},
			queryByClassIdSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.userList = data
					this.teacherInfo = this.userList[0].classInfo.teacherInfo
				}
			},
			tolive() {
				axios.get('/itmswcn/maintain/classLive/openRoom/' + this.cid)
					.then(this.getOpenRoomSucc)
			},
			getOpenRoomSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					window.open("https://itmsw.cn/live/live.html?cid=" + data.classId + "&rid=" + data.roomId + "&rstr=" + data.randStr)
				}
			},
			tochart() {
				window.open("https://itmsw.cn/chart/home.html")
			},
			getDataInfo() {
				axios.get('/itmswcn/maintain/classInfo/queryList')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.classList = data
					this.cid = data[0].id
					this.cname = data[0].className
					this.queryByClassId(this.cid)
				}
			},
			toChapter(id) {
				window.open('https://itmsw.com/lesson/75.html?id=' + id)
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	#main {
		margin-bottom: 50px;
	}
	
	#sz-banner {
		position: relative;
		height: 168px;
		background: url('../../../assets/img/temp2.png') no-repeat center top #000;
		background-size: cover;
	}
	
	#sz-banner .info-bg {
		overflow: hidden;
		z-index: 0
	}
	
	#sz-banner .info-bg,
	#sz-banner .info-bg .cover-canvas,
	#sz-banner .info-bg .cover-img-wrap,
	#sz-banner .info-bg .cover-mask {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 188px
	}
	
	#sz-banner .info-bg .cover-img-wrap {
		z-index: 0;
		overflow: hidden
	}
	
	#sz-banner .info-bg .cover-img-wrap img {
		position: absolute;
		left: 0;
		top: 0
	}
	
	#sz-banner .wrap {
		width: 1152px;
		margin-left: auto;
		margin-right: auto;
		position: relative
	}
	
	#sz-banner .sz-banner-left,
	#sz-banner .sz-banner-right {
		height: 168px;
		position: relative
	}
	
	#sz-banner .sz-banner-left {
		float: left;
		width: 100%
	}
	
	#sz-banner .sz-banner-right {
		position: absolute;
		right: 0;
		top: 0;
		width: 304px
	}
	
	#sz-banner .course-notice {
		position: absolute;
		top: 24px;
		right: 0;
		width: 68px;
		height: 32px;
		background: rgba(255, 153, 0, .8);
		box-shadow: 0 2px 4px 0 rgba(7, 17, 27, .2);
		border-radius: 16px;
		padding: 6px 12px;
		box-sizing: border-box;
		cursor: pointer;
		overflow: hidden;
		transition: .3s all linear
	}
	
	#sz-banner .course-notice:hover {
		background: #f90
	}
	
	#sz-banner .course-notice i,
	#sz-banner .course-notice span {
		float: left;
		color: #fff;
		line-height: 20px
	}
	
	#sz-banner .course-notice i {
		font-size: 16px;
		margin-right: 4px
	}
	
	#sz-banner .course-notice span {
		font-size: 12px
	}
	
	#sz-banner .course-notice .course-new-notice {
		display: none
	}
	
	#sz-banner .course-notice.open {
		width: 304px;
		height: 140px;
		padding: 16px 24px;
		background: #f90;
		box-shadow: 0 8px 16px 0 rgba(7, 17, 27, .2);
		border-radius: 8px;
		z-index: 1;
		cursor: default
	}
	
	#sz-banner .course-notice.open i {
		font-size: 20px
	}
	
	#sz-banner .course-notice.open span {
		font-size: 14px
	}
	
	#sz-banner .course-notice.open .course-new-notice {
		display: block
	}
	
	#sz-banner .course-notice.open p {
		font-size: 12px;
		color: #fff;
		line-height: 24px;
		margin: 8px 0
	}
	
	#sz-banner .course-notice.open .al {
		float: left;
		font-size: 12px;
		color: rgba(255, 255, 255, .6);
		line-height: 24px
	}
	
	#sz-banner .course-notice.open .al:hover {
		color: #fff
	}
	
	#sz-banner .course-notice.open .ar {
		float: right;
		color: #fff;
		line-height: 24px
	}
	
	#sz-banner .course-notice.open .ar span {
		float: left;
		font-size: 12px;
		margin-right: 4px
	}
	
	#sz-banner .course-notice.open .ar i {
		float: left;
		font-size: 16px
	}
	
	#sz-banner .crumbs {
		padding-top: 16px
	}
	
	#sz-banner .crumbs a,
	#sz-banner .crumbs i,
	#sz-banner .crumbs span {
		float: left;
		font-size: 12px;
		line-height: 24px;
		color: rgba(255, 255, 255, .6)
	}
	
	#sz-banner .crumbs a:hover {
		color: #fff
	}
	
	#sz-banner .crumbs i {
		margin: 0 4px;
		font-style: normal;
		width: 6px;
		text-align: center
	}
	
	#sz-banner .course-title {
		padding-top: 5px;
		font-size: 32px;
		color: #fff;
		height: 45px;
		line-height: 36px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		word-break: break-word
	}
	
	#sz-banner .course-title a {
		font-size: 28px;
		color: #fff
	}
	
	#sz-banner .shizhan-nav {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		z-index: 1
	}
	
	#sz-banner .shizhan-nav a {
		float: left;
		width: 120px;
		height: 50px;
		padding: 10px 26px 16px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	
	#sz-banner .shizhan-nav a:not(:last-child) {
		margin-right: 72px
	}
	
	#sz-banner .shizhan-nav a:hover i,
	#sz-banner .shizhan-nav a:hover span {
		color: #fff
	}
	
	#sz-banner .shizhan-nav a.on {
		background: #f8fafc;
		border-radius: 4px 4px 0 0
	}
	
	#sz-banner .shizhan-nav a.on i {
		color: #f01414
	}
	
	#sz-banner .shizhan-nav a.on span {
		color: #2b333b
	}
	
	#sz-banner .shizhan-nav i,
	#sz-banner .shizhan-nav span {
		color: rgba(255, 255, 255, .6);
		line-height: 32px
	}
	
	#sz-banner .shizhan-nav i {
		float: left;
		font-size: 28px
	}
	
	#sz-banner .shizhan-nav span {
		float: right;
		font-size: 16px
	}
	
	#sz-banner .wrap-other {
		position: relative;
		height: 150px
	}
	
	#sz-banner .wrap-other img {
		display: block;
		width: 100%;
		height: 150px
	}
	
	#sz-banner .wrap-other .user-info {
		position: absolute;
		left: 50%;
		top: 0;
		margin-left: -600px;
		width: 1000px;
		padding-left: 168px;
		height: 100%
	}
	
	#sz-banner .wrap-other .user-info a {
		position: absolute;
		left: 0;
		bottom: -20px;
		width: 132px;
		height: 132px;
		border: 4px solid rgba(255, 255, 255, .2);
		border-radius: 50%;
		overflow: hidden
	}
	
	#sz-banner .wrap-other .user-info img {
		width: 132px;
		height: 132px
	}
	
	#sz-banner .wrap-other .user-info h3 {
		font-size: 32px;
		font-weight: 600;
		color: #fff;
		line-height: 40px;
		margin-top: 48px;
		margin-bottom: 18px
	}
	
	#sz-banner .wrap-other .user-info span {
		color: #fff;
		font-size: 14px;
		line-height: 20px;
		text-align: left;
		opacity: .5
	}
	
	#sz-banner .wrap-other .user-info i {
		font-style: normal;
		margin: 0 20px;
		color: #fff;
		opacity: .2
	}
	
	#sz-banner .wrap-other .user-info em {
		margin-left: 8px
	}
	
	.learn-container {
		width: 1152px;
		padding-top: 16px;
		padding-bottom: 16px;
		box-sizing: border-box;
		position: relative;
		margin-left: auto;
		margin-right: auto
	}
	
	.learn-container .learn-container-left {
		float: left;
		position: relative;
		width: 800px
	}
	
	.learn-container .learn-course-right {
		float: right;
		width: 304px;
		padding-top: 20px
	}
	
	.learn-container .learn-container-nav {
		height: 48px;
		padding: 0 16px
	}
	
	.learn-container .learn-container-nav a {
		float: left;
		margin-right: 48px;
		font-size: 14px;
		line-height: 48px;
		color: #4d555d;
		box-sizing: border-box
	}
	
	.learn-container .learn-container-nav a:hover {
		color: #07111b
	}
	
	.learn-container .learn-container-nav a.active {
		color: #f01414;
		border-bottom: 2px solid #f01414
	}
	
	.learn-container .learn-container-nav a.view-wiki {
		color: #f01616;
		float: right;
		margin-right: 0;
		position: relative;
		right: -16px
	}
	
	.learn-container .learn-container-nav a.view-wiki:hover {
		color: #c20a0a
	}
	
	.learn-container .learn-container-nav a.view-wiki i {
		padding-left: 4px
	}
	
	.learn-container .learning_progress {
		width: 800px;
		height: 72px;
		background: #fff;
		box-shadow: 0 2px 4px 0 rgba(7, 17, 27, .1);
		border-radius: 8px;
		padding: 18px 24px;
		box-sizing: border-box
	}
	
	.learn-container .learning_progress .learning_progress_head {
		float: left;
		width: 36px;
		height: 36px;
		margin-right: 24px;
		border-radius: 50%;
		overflow: hidden
	}
	
	.learn-container .learning_progress dl {
		float: left;
		margin-right: 24px
	}
	
	.learn-container .learning_progress dt {
		font-size: 12px;
		color: #4d555d;
		line-height: 18px
	}
	
	.learn-container .learning_progress dd {
		font-size: 16px;
		color: #f01414;
		line-height: 18px
	}
	
	.learn-container .learning_progress dd label {
		font-size: 12px;
		display: inline-block;
		line-height: 18px;
		color: rgba(240, 20, 20, .4);
		margin-left: 8px
	}
	
	.learn-container .learning_progress span {
		float: right;
		font-size: 12px;
		color: #93999f;
		line-height: 36px;
		max-width: 180px;
		overflow: hidden;
		margin-right: 12px;
		height: 36px;
		word-wrap: break-word;
		white-space: nowrap;
		text-overflow: ellipsis
	}
	
	.learn-container .learning_progress .continue_learn {
		float: right;
		width: 104px;
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		color: #fff;
		background: #f01414;
		border-radius: 18px;
		text-align: center
	}
	
	.learn-container .learning_progress_fixed {
		position: fixed;
		bottom: 0;
		box-shadow: 0 0 8px 0 rgba(7, 17, 27, .1);
		border-radius: 4px 4px 0 0;
		visibility: hidden
	}
	
	.learn-container .learning_zw_fixed {
		position: fixed;
		width: 800px;
		height: 72px;
		bottom: 0;
		visibility: hidden
	}
	
	.learn-container .learn-course-list {
		padding-top: 16px
	}
	
	body {
		background-color: #f8fafc
	}
	
	.list-item {
		padding: 24px 32px 20px;
		background: #fff;
		box-shadow: 0 2px 4px 0 rgba(7, 17, 27, .1);
		border-radius: 8px;
		margin-bottom: 16px;
		transition: .3s all linear
	}
	
	.list-item ul {
		margin: 0;
		padding: 0;
	}
	
	.list-item:hover {
		box-shadow: 0 8px 16px 0 rgba(7, 17, 27, .1)
	}
	
	.list-item h3 {
		position: relative;
		font-size: 16px;
		color: #07111b;
		line-height: 32px;
		margin-bottom: 8px
	}
	
	.list-item h3 span {
		font-size: 12px;
		color: #93999f;
		line-height: 32px;
		position: absolute;
		right: 0
	}
	
	.list-item h3 .new_tag {
		display: inline-block;
		color: #fff;
		width: 30px;
		height: 18px;
		background-image: url(/static/module/common/img/new_tags_list.png);
		background-size: cover;
		vertical-align: middle;
		margin-left: 4px
	}
	
	.list-item li {
		position: relative;
		height: 48px;
		padding: 0 12px 0 82px;
		font-size: 14px;
		box-sizing: border-box;
		transition: .3s all linear;
		overflow: hidden
	}
	
	.list-item li i.ileft {
		color: #07111b
	}
	
	.list-item li i.ileft.imv2-wancheng3 {
		color: #1fad4e
	}
	
	.list-item li .type-text {
		color: #07111b
	}
	
	.list-item li.learned a {
		color: #93999f
	}
	
	.list-item li.learned i.ileft {
		color: #d9dde1
	}
	
	.list-item li.learned .type-text {
		color: #93999f
	}
	
	.list-item li.finished a {
		color: #93999f
	}
	
	.list-item li.finished i.ileft {
		color: #d9dde1
	}
	
	.list-item li.finished i.ileft.imv2-wancheng3 {
		color: #1fad4e
	}
	
	.list-item li.finished .type-text {
		color: #93999f
	}
	
	.list-item li:hover {
		background: #f8fafc;
		border-radius: 4px
	}
	
	.list-item li:hover a {
		color: #07111b
	}
	
	.list-item li:hover i.ileft {
		color: #07111b
	}
	
	.list-item li:hover i.ileft.imv2-wancheng3 {
		color: #1fad4e
	}
	
	.list-item li:hover .type-text {
		color: #07111b
	}
	
	.list-item li i.imv2-tick {
		color: #37f!important
	}
	
	.list-item li .title_info {
		display: inline-block;
		max-width: 572px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: middle
	}
	
	.list-item li .is_new_img {
		display: inline-block;
		color: #fff;
		width: 34px;
		height: 18px;
		background-image: url(/static/module/common/img/new_icon.png?v=1);
		background-size: cover;
		vertical-align: middle;
		margin-left: 4px
	}
	
	.list-item li .new_tag {
		display: inline-block;
		color: #fff;
		width: 30px;
		height: 18px;
		background-image: url(/static/module/common/img/new_tags_list.png);
		background-size: cover;
		vertical-align: middle;
		margin-left: 4px
	}
	
	.list-item a {
		display: block;
		color: #4d555d;
		line-height: 44px;
		transition: .3s all linear;
		position: relative
	}
	
	.list-item a .course-time {
		margin-left: 8px;
		font-size: 13px;
		line-height: 48px;
		font-weight: 400
	}
	
	.list-item a .r {
		float: right;
	}
	
	.list-item i.ileft {
		position: absolute;
		left: 12px;
		top: 16px;
		font-size: 16px;
		line-height: 16px;
		transition: .3s all linear
	}
	
	.list-item .type-text {
		position: absolute;
		top: 0;
		left: 40px;
		font-size: 14px;
		line-height: 48px;
		font-weight: 700;
		transition: .3s all linear
	}
	
	.list-item i.iright {
		position: absolute;
		right: 12px;
		top: 16px;
		font-size: 12px;
		color: #d9dde1;
		line-height: 16px
	}
	
	.list-item i.iright.pink {
		color: rgba(240, 20, 20, .4)
	}
	
	.course-sidebar-title h3 .span {
		float: left;
		font-size: 16px;
		color: #07111b;
		line-height: 24px
	}
	
	.course-sidebar-title h3 a {
		float: right;
		font-size: 12px;
		color: #93999f;
		line-height: 24px
	}
	
	.course-sidebar-title h3 a span {
		margin-right: 4px
	}
	
	.course-sidebar-title h3 a i,
	.course-sidebar-title h3 a span {
		float: left;
		font-style: normal
	}
	
	.course-sidebar-title h3 a:hover {
		color: #07111b
	}
	
	.course-sidebar {
		margin-bottom: 16px;
		border-radius: 8px;
		padding: 24px;
		box-sizing: border-box
	}
	
	.course-sidebar .href_btn {
		display: block;
		width: 160px;
		height: 36px;
		line-height: 36px;
		border-radius: 18px;
		font-size: 14px;
		color: #fff;
		text-align: center;
		transition: .3s all linear
	}
	
	.course-sidebar.evaluate {
		margin: 12px 0 16px;
		height: 256px;
		padding: 24px 4px;
		background-color: #eff2f5;
		position: relative
	}
	
	.course-sidebar.evaluate h2 {
		font-size: 16px;
		color: #07111b;
		text-align: center;
		line-height: 16px;
		font-weight: 700;
		margin-bottom: 8px
	}
	
	.course-sidebar.evaluate h3 {
		font-size: 32px;
		color: #fa0;
		text-align: center;
		line-height: 32px;
		font-weight: 700;
		margin-bottom: 8px
	}
	
	.course-sidebar.evaluate .course-score {
		margin-bottom: 8px
	}
	
	.course-sidebar.evaluate .course-score .stars {
		display: block;
		width: 100px;
		margin-left: auto;
		margin-right: auto
	}
	
	.course-sidebar.evaluate .course-score i {
		font-size: 16px;
		line-height: 16px;
		color: rgba(255, 153, 0, .4)
	}
	
	.course-sidebar.evaluate .course-score i.on {
		color: #f90
	}
	
	.course-sidebar.evaluate .course-score em {
		position: relative
	}
	
	.course-sidebar.evaluate .course-score em i {
		color: rgba(255, 153, 0, .4)
	}
	
	.course-sidebar.evaluate .course-score .sz-star-h {
		color: #f90!important;
		position: absolute;
		top: 0;
		left: 0
	}
	
	.course-sidebar.evaluate .href_btn {
		margin-bottom: 8px;
		margin-left: auto;
		margin-right: auto;
		background: rgba(255, 153, 0, .8)
	}
	
	.course-sidebar.evaluate .href_btn:hover {
		background: #f90
	}
	
	.course-sidebar.evaluate .href_btn.look {
		border: 1px solid #f90;
		background-color: #eff2f5;
		color: #f90
	}
	
	.course-sidebar.evaluate .href_btn.look:hover {
		background: #f90;
		color: #fff
	}
	
	.course-sidebar.evaluate p {
		width: 256px;
		margin-left: auto;
		margin-right: auto;
		font-size: 12px;
		color: #93999f;
		line-height: 20px;
		padding-bottom: 16px;
		margin-bottom: 16px;
		border-bottom: 1px solid #d9dde1;
		text-align: center;
		font-weight: 300
	}
	
	.course-sidebar.evaluate p a {
		color: rgba(255, 153, 0, .6)
	}
	
	.course-sidebar.evaluate p a:hover {
		color: #f90
	}
	
	.course-sidebar.evaluate dl {
		float: left;
		width: 96px;
		margin-right: 4px;
		text-align: center
	}
	
	.course-sidebar.evaluate dl:last-child {
		margin-right: 0
	}
	
	.course-sidebar.evaluate dt {
		font-size: 12px;
		color: #07111b;
		line-height: 16px;
		margin-bottom: 2px
	}
	
	.course-sidebar.evaluate dd {
		font-size: 12px;
		color: #4d555d;
		line-height: 16px;
		font-weight: 300
	}
	
	.course-sidebar.evaluate .strategy {
		display: none;
		position: absolute;
		top: 42px;
		right: -42px;
		width: 230px;
		height: 102px;
		background: #f90;
		box-shadow: 0 2px 4px 0 rgba(7, 17, 27, .2);
		border-radius: 2px;
		padding: 12px 16px 12px;
		font-size: 12px;
		color: #fff;
		line-height: 20px;
		text-align: center;
		box-sizing: border-box
	}
	
	.course-sidebar.evaluate .strategy .sanjiao {
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-top: 10px solid #f90;
		position: absolute;
		bottom: -20px;
		left: 87px
	}
	
	.course-sidebar.porject {
		background-color: #eff2f5;
		margin-bottom: 16px;
		text-align: center;
		position: relative
	}
	
	.course-sidebar.porject .item {
		position: relative
	}
	
	.course-sidebar.porject h4 {
		font-size: 14px;
		color: #07111b;
		margin-bottom: 2px;
		vertical-align: middle
	}
	
	.course-sidebar.porject h4 i {
		font-size: 14px;
		color: rgba(240, 20, 20, .8);
		margin-left: 2px;
		cursor: pointer
	}
	
	.course-sidebar.porject .token-intro {
		display: none;
		font-size: 12px;
		color: #545c63;
		line-height: 40px;
		width: 352px;
		height: 40px;
		text-align: center;
		background: #fff;
		box-shadow: 0 8px 16px 0 rgba(28, 31, 33, .2);
		border-radius: 8px;
		position: absolute;
		right: 90px;
		top: -9px
	}
	
	.course-sidebar.porject .token-box {
		background: #fff;
		border-radius: 8px;
		overflow: hidden;
		margin-top: 6px
	}
	
	.course-sidebar.porject .token-box a:first-child {
		font-size: 14px;
		color: #1c1f21;
		line-height: 30px;
		cursor: default;
		font-weight: 700;
		text-align: center;
		width: 208px
	}
	
	.course-sidebar.porject .token-box a:first-child.endline {
		text-decoration: line-through;
		color: #b2b8bd;
		font-weight: 400
	}
	
	.course-sidebar.porject .token-box a:last-child {
		background: #ef4041;
		font-size: 14px;
		color: #fff;
		line-height: 30px;
		text-align: center;
		width: 48px
	}
	
	.course-sidebar.porject .token-box a:last-child.disabled {
		cursor: not-allowed;
		background: rgba(242, 13, 13, .4)
	}
	
	.course-sidebar.porject .token-tip-box {
		margin-top: 8px;
		text-align: center
	}
	
	.course-sidebar.porject .token-tip-box .tip {
		font-size: 12px;
		color: #93999f;
		line-height: 17px
	}
	
	.course-sidebar.porject .token-tip-box .new-token {
		font-size: 12px;
		color: rgba(240, 20, 20, .8);
		line-height: 17px;
		margin-left: 13px
	}
	
	.course-sidebar.porject .project_href a {
		font-size: 12px;
		color: rgba(240, 20, 20, .6);
		line-height: 20px;
		cursor: default
	}
	
	.course-sidebar.porject .project_href a:hover {
		color: #f01414
	}
	
	.course-sidebar.porject p {
		font-size: 12px;
		color: #93999f;
		line-height: 20px;
		font-weight: 300
	}
	
	.course-sidebar.porject p span {
		display: inline-block;
		margin-left: 2px
	}
	
	.course-sidebar.porject .item:first-child {
		margin-top: 0
	}
	
	.course-sidebar.porject .item:last-child {
		padding-bottom: 0;
		border-bottom: none
	}
	
	.course-sidebar.porject .item {
		margin-top: 24px;
		padding-bottom: 24px;
		border-bottom: 1px solid #d9dde1
	}
	
	.course-sidebar.porject .item .title {
		font-size: 16px;
		font-weight: 700;
		color: #07111b;
		text-align: center;
		margin-bottom: 8px
	}
	
	.course-sidebar.porject .href_btn {
		background: rgba(240, 20, 20, .6);
		margin: 8px auto
	}
	
	.course-sidebar.porject .href_btn:hover {
		background: #f01414
	}
	
	.course-sidebar.porject .href_btn.disabled {
		cursor: default;
		background: #d9dde1
	}
	
	.course-sidebar.porject .qrcode-box {
		top: 82px;
		right: 22px
	}
	
	.course-sidebar.coupon {
		background-color: #eff2f5;
		margin-bottom: 20px;
		text-align: center
	}
	
	.course-sidebar.coupon h4 {
		font-size: 16px;
		color: #f01414;
		line-height: 24px;
		margin-bottom: 4px
	}
	
	.course-sidebar.coupon h4 span {
		font-weight: 700;
		margin-right: 4px
	}
	
	.course-sidebar.coupon p {
		font-size: 12px;
		color: #93999f;
		line-height: 20px;
		margin-bottom: 12px
	}
	
	.course-sidebar.coupon .href_btn {
		width: 104px;
		background: rgba(240, 20, 20, .6);
		margin-left: auto;
		margin-right: auto
	}
	
	.course-sidebar.coupon .href_btn:hover {
		background: #f01414
	}
	
	a {
		text-decoration: none !important;
	}
</style>